import { Info } from 'lucide-react';
import type { ReactNode } from 'react';

import { Tooltip } from '@mokoboko/components';

// The icon can sit inside a clickable row: a tap on it must not open the row.
export const InfoTooltip = ({
  content,
  label,
}: {
  content: ReactNode;
  label: string;
}) => (
  <Tooltip content={content} side="top">
    <button
      type="button"
      className="cursor-help"
      aria-label={label}
      onClick={(e) => e.stopPropagation()}
    >
      <Info className="h-3.5 w-3.5 text-gray-400" />
    </button>
  </Tooltip>
);
